"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseUserOnboarding = void 0;
const OnboardingId_1 = require("./OnboardingId");
const UserOnboardingStatus_1 = require("./UserOnboardingStatus");
const BaseUserOnboardingStep_1 = require("./BaseUserOnboardingStep");
const utils_1 = require("@leavy/utils");
const infrastructure_1 = require("../../infrastructure");
const validator_1 = require("@leavy/validator");
const BaseUserOnboardingExtraData_1 = require("./BaseUserOnboardingExtraData");
const BaseUserOnboardingRejectionInfo_1 = require("./BaseUserOnboardingRejectionInfo");
class BaseUserOnboarding extends infrastructure_1.AggregateRootBase {
    constructor(id, data) {
        super(id);
        this.steps = [];
        this.extraData = [];
        this.initialize(data);
    }
    get onboardingId() {
        return this.id[1];
    }
    get userId() {
        return this.id[0];
    }
    get isComplete() {
        return this.steps.every(x => x.isComplete());
    }
    /**
     * @virtual
     */
    get canSubmit() {
        return (this.status == UserOnboardingStatus_1.UserOnboardingStatus.STARTED
            && this.steps.every(x => x.isComplete() || x.isOptional));
    }
    isRejected() {
        return (this.status == UserOnboardingStatus_1.UserOnboardingStatus.REJECTED
            && !!this.rejectionInfo);
    }
    getStep(stepId, ctor) {
        const step = this.steps.find(x => x.stepId == stepId) ??
            (0, utils_1.raise)(new Error(`Step ${stepId} should exist for onboarding of type ${this.onboardingId}`));
        (0, utils_1.assert)(step instanceof ctor);
        return step;
    }
    getExtraData(dataTypeId, ctor) {
        const extraData = this.extraData.find(x => x.dataTypeId == dataTypeId) ??
            (0, utils_1.raise)(new Error(`Extra data of type ${dataTypeId} should exist for onboarding of type ${this.onboardingId}`));
        (0, utils_1.assert)(extraData instanceof ctor);
        return extraData;
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => Date),
    __metadata("design:type", Date)
], BaseUserOnboarding.prototype, "creationDate", void 0);
__decorate([
    (0, validator_1.Type)(() => Date),
    __metadata("design:type", Date)
], BaseUserOnboarding.prototype, "lastModificationDate", void 0);
__decorate([
    (0, validator_1.Type)(() => BaseUserOnboardingRejectionInfo_1.BaseUserOnboardingRejectionInfo),
    __metadata("design:type", BaseUserOnboardingRejectionInfo_1.BaseUserOnboardingRejectionInfo)
], BaseUserOnboarding.prototype, "rejectionInfo", void 0);
__decorate([
    (0, validator_1.Type)(() => BaseUserOnboardingStep_1.BaseUserOnboardingStep),
    __metadata("design:type", Array)
], BaseUserOnboarding.prototype, "steps", void 0);
__decorate([
    (0, validator_1.Type)(() => BaseUserOnboardingExtraData_1.BaseUserOnboardingExtraData),
    __metadata("design:type", Array)
], BaseUserOnboarding.prototype, "extraData", void 0);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], BaseUserOnboarding.prototype, "onboardingId", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], BaseUserOnboarding.prototype, "userId", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BaseUserOnboarding.prototype, "isComplete", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BaseUserOnboarding.prototype, "canSubmit", null);
exports.BaseUserOnboarding = BaseUserOnboarding;
//# sourceMappingURL=BaseUserOnboarding.js.map